// extracted by mini-css-extract-plugin
module.exports = {"root":"PageNotFound_root__3H_7o","adviseContainer":"PageNotFound_adviseContainer__1ZytY","fade-in":"PageNotFound_fade-in__1B8uc"};